/**
 * Order Entry - Command Enum
 * This enumeration contains identifiers for commands that can be issued
 * buy the coordinator service to the panel components.
 */
export enum OENCommand {
  // close order entry screen
  LOGOUT_CLEANUP_ORDER_ENTRY,
  /* generic panel commands */
  NEW_MODEL,
  LOAD_CONTROLS,
  LOAD_DEFAULTS,
  RESET_ALL,
  INVALID_INPUT,
  // locking cmd
  LOCK_ALL,
  UNLOCK_ALL,
  // freeze
  FREEZE,
  UNFREEZE,
  LOAD_LOCKING_PROFILE,

  // RefId management on panels
  REF_ACTIVATE,
  REF_ADD,
  REF_REMOVE,
  REF_CLEAR,
  REF_REMOVE_ROOT,
  // order entry display state
  STATE_ORDER_ENTRY,
  STATE_ORDER_IN_MODIFICATION,
  STATE_ORDER_AMEND_MARKUP,
  STATE_ORDER_UNLOCKED,
  STATE_ORDER_LOST_HIDDEN,
  STATE_ORDER_PROCESSING,
  STATE_ORDER_SUCCESS,
  STATE_MONITOR_EXECUTION,
  STATE_ORDER_REJECTED,
  STATE_ORDER_REJECTED_HCO_ERROR,
  STATE_ORDER_INT_ERROR,
  STATE_ORDER_ENTRY_TOLERANCE_WARN,
  STATE_ORDER_ENTRY_TOLERANCE_ERROR,
  STATE_ORDER_APPROVAL_ALLOWED,
  STATE_ORDER_APPROVAL_INTERNAL,
  STATE_ORDER_APPROVAL_EXTERNAL,
  STATE_ORDER_MODIFY_OUT_ACCEPTANCE,
  STATE_ORDER_EXT_MODIFY_OUT_ACCEPTANCE,
  STATE_ORDER_EXPIRY_PENDING,
  STATE_ORDER_ACCEPTANCE_ALLOWED,
  STATE_ORDER_ACCEPTANCE_EXTERNAL,
  /** The ticket is being actively modified by another user */
  STATE_ORDER_MODIFICATION_EXTERNAL,
  STATE_ORDER_ACCEPTANCE_CALL,
  STATE_REVAL_BUTTONS,

  // panels show hide - order entry screen component
  /* PANEL_SHOW_CLIENT,
    PANEL_SHOW_FINANCIALS,
    PANEL_SHOW_MORE, */
  PANEL_SHOW_STRATEGY,
  PANEL_SHOW_NOTIFICATIONS,
  PANEL_SHOW_ACTIONS,
  /* 	PANEL_HIDE_CLIENT,
        PANEL_HIDE_FINANCIALS,
        PANEL_HIDE_MORE, */
  PANEL_HIDE_STRATEGY,
  PANEL_HIDE_NOTIFICATIONS,
  PANEL_HIDE_ACTIONS,
  // TABs
  SHOW_TAB_FINANCIALS,
  SHOW_TAB_MORE,
  // panel update
  PANEL_UPDATE_STRATEGY,
  PANEL_RESET_STRATEGY,
  // More Section
  PROPAGATE_CLIENT_CHANGE,
  PROPAGATE_CLIENT_DEFAULT_COMMENTS_CHANGE,
  PROPAGATE_CLIENT_TRADER_CHANGE,
  PROPAGATE_ACCOUNT_CHANGE,
  PROPAGATE_ORDER_TYPE_CHANGE,
  PROPAGATE_MARKUP_CHANGE,
  PROPAGATE_EXECUTION_MODE_CHANGE,
  // Hide-show inputs
  SHOW_INTENT_AND_AMOUNT_INPUT,
  HIDE_INTENT_AND_AMOUNT_INPUT,
  //
  SHOW_PARTIAL_FILLS,
  HIDE_PARTIAL_FILLS,
  // markup
  SHOW_MARKUP,
  HIDE_MARKUP,
  // extended log update (used for debug)
  EXTENDED_LOG_UPDATE,
  VALIDATE,
  ATDL_CONTROL_VALIDATION,
  // save btn actions panel
  UPDATE_SAVE_BTN_AVAILABILITY,
  UPDATE_GAMMA_INELIGIBLE,
  UPDATE_GAMMA_ELIGIBLE,
  GAMMA_CUSTOMISE,
  GAMMA_RESTORE,
  GAMMA_TOP_LEG,
  GAMMA_ENABLE_CUST_BUTTON,
  GAMMA_DISABLE_CUST_BUTTON,
  GAMMA_UPDATED_CUST_LEG,
  GAMMA_NEW_LEG_RESP,
  GAMMA_CUST_CCYPAIR_UPDATE,
  SAVE_GAMMA_TO_MODEL,
  GAMMA_DUPLICATE_LOAD,
  GAMMA_CUSTOM_RATE_CHANGE,
  BULKING,
  BULKED,
  UNBULK,

  MODIFY_MONITORED_ORDER,

  /** All control loading and initialisation is done */
  CONTROL_LOADING_COMPLETE,

  /** A notification event relevant to execution of order - payload is an ActionCalloutType */
  EXECUTION_NOTIFICATION,

  FOCUS_ORDER_ENTRY,

  PROPAGATE_CLIENT_INTENT_CHANGE,

  SCROLL_IN_VIEW,
  REFRESH_STRATEGY,

  STATE_ORDER_ENTRY_NEGATIVE_MARKUP,

  BM_ZERO_AMOUNT_WARN,
}
